"use client";

import type { LDEvaluationDetail } from "launchdarkly-react-client-sdk";
import type { ReactNode } from "react";

import { basicLogger, LDProvider } from "launchdarkly-react-client-sdk";

type LaunchDarklyProviderProps = {
  children: ReactNode;
  clientSideID?: string;
  userId?: string | undefined | null; // LaunchDarkly expects string keys
  email?: string | undefined | null;
  application: "portal" | "backoffice";
};

export const LaunchDarklyProvider = ({
  children,
  clientSideID,
  userId,
  email,
  application,
}: LaunchDarklyProviderProps) => {
  if (!clientSideID) {
    return <>{children}</>;
  }
  const key = userId ? userId : email;

  const context = key
    ? {
        kind: "user",
        key: key,
        email: email,
        userId: userId,
        application,
      }
    : undefined;

  return (
    <LDProvider
      clientSideID={clientSideID}
      context={context}
      options={{
        bootstrap: "localStorage",
        logger: basicLogger({ level: "warn" }),
        inspectors: [
          {
            type: "flag-used",
            name: "dd-inspector",
            method: (key: string, detail: LDEvaluationDetail) => {
              if (
                typeof (window as any).DD_RUM?.addFeatureFlagEvaluation ===
                "function"
              ) {
                (window as any).DD_RUM.addFeatureFlagEvaluation(
                  key,
                  detail.value,
                );
              }
            },
          },
        ],
      }}
      reactOptions={{
        useCamelCaseFlagKeys: false,
      }}
    >
      {children}
    </LDProvider>
  );
};
